import { Link } from 'react-router-dom'
import { useI18n } from '@/i18n'
import { Container } from '@/components/layout/Container'
import { Button } from '@/components/ui/Button'

/** 404. Wired up by App.tsx as the catch-all route — no registry entry needed. */
export default function NotFound() {
  const { t } = useI18n()

  return (
    <Container size="sm" data-upbo-id="page-not-found" data-upbo-label="404 page">
      <div className="py-28 sm:py-36 flex flex-col items-center text-center gap-5">
        <span className="font-display text-[96px] leading-none text-border-strong">404</span>
        <h1 className="font-display text-[34px] leading-tight">{t('notFound.title')}</h1>
        <p className="text-sm text-text-muted max-w-sm">{t('notFound.body')}</p>
        <Link to="/" className="mt-2">
          <Button>{t('notFound.button')}</Button>
        </Link>
      </div>
    </Container>
  )
}
